import * as React from 'react';
import { DropDownListComponent } from '../DropDownList/DropDownListComponent';
import { ItemList } from '../../types/logbook-type';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { useOrganizationList } from '../../data/DataProviders/OrganizationListProvider';
import { useDispatch } from 'react-redux';
import { Thunks } from '../../actions';

export interface Props {
    defaultValue: string;
    callback: (organizationId: string) => void;
}

const OrganizationFilterSelect: React.FunctionComponent<Props> = (props) => {

    const { defaultValue, callback } = props;
    
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const useOrganizationDataList = useOrganizationList();

    const [organizationListData, setOrganizationListData] = React.useState<ItemList>([]);

    const handleChange = (organizationId: string) => {
        dispatch(Thunks.Customer.getCustomerListV2(organizationId));
        dispatch(Thunks.Asset.getDeviceList(organizationId, '', '', '', '', '', '', ''));
        callback(organizationId);
    }

    React.useEffect(() => {
        setOrganizationListData(useOrganizationDataList.organizationList);
    }, [useOrganizationDataList, useOrganizationDataList.organizationList]); //eslint-disable-line react-hooks/exhaustive-deps

    return (
        <DropDownListComponent
            disabled={false}
            data-testid="asset-organization-filter"
            list={organizationListData}
            value={t('SEARCH.ALL_ORGANIZATIONS')}
            handleSelection={handleChange}
            selected={''}
            defaultSelection={defaultValue}>
        </DropDownListComponent>
    );
};

export default OrganizationFilterSelect;
